import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import uuid from "react-uuid";

import NavigationGroup from "../../model/NavigationGroup";
import MenuItem from "./MenuItem";

interface IActiveStyle {
    color: string;
}

interface IMenu {
    authorizedNavGroupItems: NavigationGroup[];
    open: boolean;
    setOpen: (value: boolean) => void;
    forceUpdate: boolean;
    setForceUpdate: (value: boolean) => void;
    activeStyle: IActiveStyle;
    menuItem: (title: string) => React.ReactNode;
}

const Menu: React.FC<IMenu> = ({
    authorizedNavGroupItems,
    open,
    setOpen,
    forceUpdate,
    setForceUpdate,
    activeStyle,
    menuItem,
}) => {
    const menuItems = authorizedNavGroupItems?.map(
        ({ icon, title, navItems }) => (
            <MenuItem
                open={open}
                setOpen={(value) => setOpen(value)}
                forceUpdate={forceUpdate}
                setForceUpdate={(value) => setForceUpdate(value)}
                activeStyle={activeStyle}
                menuItem={menuItem}
                title={title}
                icon={icon}
                navItems={navItems}
                key={uuid()}
            />
        )
    );

    return (
        <Container
            style={{
                display: "block",
                alignItems: "flex-start",
                paddingTop: "90px",
                justifyContent: "center",
                textAlign: "center",
            }}
        >
            {menuItems}
        </Container>
    );
};

export default Menu;
